import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton, Button, Tooltip } from '@material-ui/core';
import { MenuBook, Cancel, ThumbDown, ThumbUpAlt } from '@material-ui/icons';
import { UPDATE_TITLE_PAGINATION } from '../../../queries/titleContent';
import Loading from '../../../components/Loading';
import { Toast } from '../../../components/Toast';

interface IPaginationTitlesProps {
  selectedTitles: Map<string, ITitle>;
  refetch: any;
}

const PaginationTitles: React.FC<IPaginationTitlesProps> = ({ selectedTitles, refetch }) => {
  const [openLoading, setOpenLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [updatePaginationTitle] = useMutation(UPDATE_TITLE_PAGINATION);

  const handleClose = () => {
    setOpenConfirmation(false);
  };

  const updatePagination = async (id: string, pagination: boolean) => {
    await updatePaginationTitle({
      variables: {
        id,
        pagination,
      },
    });
  };

  const setPagination = async (status: boolean) => {
    setOpenLoading(true);
    try {
      selectedTitles.forEach(async (title) => {
        await updatePagination(title.id, status);
      });
    } catch (error) {
      setOpenLoading(false);
      Toast('Failed to update pagination on Titles!', 'error');
    } finally {
      setOpenLoading(false);
      Toast('Titles pagination update sucessfully!');
      refetch(false);
      handleClose();
    }
    handleClose();
    setOpenLoading(false);
  };

  return (
    <>
      <Tooltip title="Enable/Disable pagination on Title">
        <IconButton
          color="primary"
          aria-label="pagination"
          onClick={
            e => {
              e.preventDefault();
              setOpenConfirmation(true);
            }
          }
        >
          <MenuBook />
        </IconButton>
      </Tooltip>
      <Loading openLoading={openLoading} />
      <Dialog
        open={openConfirmation}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Pagination</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Would you like to
            {' '}
            <b>ENABLE</b>
            {' '}
            or
            {' '}
            <b>DISABLE</b>
            {' '}
            pagination for these Titles ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose()}
            color="default"
          >
            <Cancel />
            {'  '}
            Cancel
          </Button>
          <Button
            onClick={() => setPagination(false)}
            color="primary"
          >
            <ThumbDown />
            {'  '}
            DISABLE
          </Button>
          <Button
            onClick={() => setPagination(true)}
            color="primary"
            autoFocus
            variant="contained"
          >
            <ThumbUpAlt />
            {'  '}
            ENABLE
          </Button>

        </DialogActions>
      </Dialog>
    </>
  );
};

export default PaginationTitles;
